<template>
    <el-form-item label="Adı" label-position="top" class="w-100">
        <el-input v-model="value.name" :disabled="true" placeholder="Tam adı" class="input-with-select">
            <template #append>
                <el-button :disabled="disabled" :icon="Plus" @click="dialogVis = true" />
            </template>
        </el-input>
    </el-form-item>

    <div class="w-100">
        <div class="row mt-3">
            <el-form-item label="Ünvan" label-position="top">
                <el-input v-model="value.address" :disabled="disabled"/>
            </el-form-item>
        </div>
        <div class="row mt-3">
            <el-form-item label="Telefon" label-position="top">
                <el-input v-model="value.phone" :disabled="disabled"/>
            </el-form-item>
        </div>
        <div class="row mt-3" v-if="sector">
            <el-form-item label="Biznes sektoru" label-position="top">
                <el-select v-model="value.clientSector" collapse-tags collapse-tags-tooltip placeholder="Seçin">
                    <el-option label="Müəyyən edilməmiş" :value="0" />
                    <el-option label="Neft sektoru" :value="1" />
                    <el-option label="Qeyri-neft sektoru" :value="2" />
                </el-select>
            </el-form-item>
        </div>
    </div>
    <el-dialog :close-on-click-modal="false" v-model="dialogVis" class="mt-7" width="60%" title="Müştəri" modal-class="modal-class"
        :destroy-on-close="true">
        <person :onlyP="onlyP" :onlyC="onlyC" @chose-client="SelectClient(); this.dialogVis = false"></person>
    </el-dialog>
</template>

<script>
import { Plus } from "@element-plus/icons-vue";
import Person from './Person.vue';

export default {
    components: { Person },
    props: {
        onlyP: { type: Boolean, default: false },
        onlyC: { type: Boolean, default: false },
        propvalue: Object,
        disType: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        insType: { type: String, default: 'c' },
        onlyName: { type: Boolean, default: false },
        sector: { type: Boolean, default: false }
    },
    data() {
        return {
            Plus,
            dialogVis: false,
            value: {},
            list: [
                // --- Физические лица ---
                { clientId: 1, displayName: "Elvin Məmmədov", pin: "AZE1234567", dateOfBirthStr: "12.03.1990", address: "Bakı, Nərimanov", phone: "+994501234567", type: "p" },
                { clientId: 2, displayName: "Leyla Quliyeva", pin: "AZE7654321", dateOfBirthStr: "05.08.1985", address: "Gəncə, Nizami", phone: "+994552223344", type: "p" },
                { clientId: 3, displayName: "Rauf Əliyev", pin: "AZE9988776", dateOfBirthStr: "22.11.1975", address: "Sumqayıt", phone: "+994702223344", type: "p" },

                // --- Юридические лица ---
                { clientId: 10, displayName: "ABC MMC", pin: "123456789", address: "Bakı, Xətai", phone: "+994124567890", type: "c" },
                { clientId: 11, displayName: "Xəzər Holdinq", pin: "223344556", address: "Sumqayıt", phone: "+994124445566", type: "c" },
                { clientId: 12, displayName: "Beta Group ASC", pin: "998877665", address: "Gəncə", phone: "+994704445566", type: "c" }
            ],
            nameSearch: null,
            insuredType: 'c',
            options: [],
            limit: 4,
            searched: false,
            loading: false
        }
    },  
    methods: {
        SelectClient() {
            this.value = {
                "id": 1,
                "name": this.onlyP ? 'Məmmədov Əli İlham' : 'Xəzər Holdinq MMC',
                "type": 'c',
                "address": "Bakı şəhəri, Nərimanov r., Ağa Nemətulla küç., ev 25",
                "phone":  "0501234567",
                "identNumber": "3AZ5K89L",

            }
        } 
    } 
}
</script>
<style scoped>
::v-deep(.el-input__wrapper) {
    background-color: white !important; 
}

::v-deep(.el-input-group__append) {
    color: white !important;
    background-color: #4db2e5 !important;
}

.insured-search ::v-deep(.el-input__wrapper) {
    display: none !important;
}

.insured-search ::v-deep(.el-select__wrapper) {
    background-color: white !important;
}

.el-input ::v-deep(.el-input-group__append .el-select__wrapper) {
    box-shadow: 0 0 0 1px var(--el-border-color) inset !important;
}

.el-input ::v-deep(.el-input-group__append .el-select__wrapper.is-focused) {
    box-shadow: 0 0 0 1px var(--el-color-primary) inset !important;
}
</style>